import type { Cafe } from 'src/types/types';
import { Container } from 'src/components/Container/Container';
import { CafeMeta } from 'src/components/CafeMeta/CafeMeta';

import styles from './styles.module.scss';

type FooterProps = {
  cafe: Cafe;
};

export const Footer = ({ cafe }: FooterProps) => (
  <footer className={styles.footer}>
    <Container>
      <div className={styles.inner}>
        <p className={styles.name}>{cafe.name}</p>
        <CafeMeta
          address={cafe.address}
          hours={cafe.hours}
          phone={cafe.phone}
          email={cafe.email}
        />
      </div>
      <div className={styles.block}></div>
      <div className={styles.block}>
        <p className={styles.tagline}>
          Дякуємо, що завітали! Будемо раді бачити вас знову
        </p>
      </div>
    </Container>
  </footer>
);
